import {atom} from 'recoil';

export const leftMenuOpenState = atom({
  key: 'leftMenuOpenState',
  default: true,
});
